import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FeatureReleaseBannerComponent } from '@common/feature-release/feature-release-banner/feature-release-banner.component';
import { FeatureFlagModule } from '@directive/feature-flag/feature-flag.module';
import { NgxPermissionsModule } from 'ngx-permissions';
import { MenuComponent } from './menu.component';

@NgModule({
  imports: [CommonModule, FormsModule, RouterModule, NgxPermissionsModule, FeatureFlagModule, FeatureReleaseBannerComponent],
  declarations: [MenuComponent],
  exports: [MenuComponent, FeatureReleaseBannerComponent],
})
export class MenuModule {}
